module.exports = __webpack_public_path__ + "static/turnaround-2a61f3617bd9792b46b751ec0c5914ce.png";